import { injectable } from 'inversify';

import { getEnvironment } from '@shared/utils/env';
import { UserManager } from 'oidc-client-ts';
import config from './userManagerConfig.json';

@injectable()
export default class AuthManager {
  static diToken = Symbol('authManager');
  private _config;

  private userManager: UserManager | undefined;

  initialize() {
    const env = getEnvironment();
    const userManagerConfig = env ? config[env] : config.Local;
    this._config = userManagerConfig;
    this.userManager = new UserManager(userManagerConfig);
  }

  get() {
    return this.userManager;
  }

  config() {
    return this._config;
  }
}
